import { FC, ReactNode } from 'react'

interface IAccordionCard {
    children: ReactNode
    contentTitle: ReactNode
    isShow: boolean
    contentClassName?: string
}

const AccordionCard: FC<IAccordionCard> = ({ children, isShow = true, contentTitle, contentClassName = "" }) => {
    return (
        <div className="col-sm-12">
            <div className="card-header" id="headingOne" >

                {contentTitle}

                {/* <h2 className="mb-0">
                    <button className={`btn btn-link btn-block text-${i18n.language == 'ar' ? 'right' : 'left'}`} type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        {t(title)}
                    </button>
                </h2> */}
            </div>

            <div id="collapseOne" className={`collapse ${isShow ? 'show' : ''} card-body-row`} aria-labelledby="headingOne" data-parent="#accordionExample">
                <div className={`card-body ${contentClassName}`}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default AccordionCard